export const CHAT_PROMPT_ALERTS = {
    SYSTEM_GREETING: {
        title: "상담 환영인사",
        value: "SYSTEM_GREETING",
        text: "방문해주셔서 감사합니다. 어떻게 도와드릴까요?",
        desc: "상담 시작 시 전달하는 환영인사 문구입니다.",
    },
    CS_PHONE_NUMBER: {
        title: "고객센터 안내",
        value: "CS_PHONE_NUMBER",
        text: "고객센터로 문의 부탁드립니다.",
        desc: "상담 질의 중 답변할 수 없는 질문에 대한 응답입니다.\r\n사이트 메뉴 안내 또는 고객센터 전화번호 안내를 입력해주세요.",
    },
};
